/**
 * Orca AI product split — one shared backend, two frontend builds.
 *
 * Set REACT_APP_ORCA_PRODUCT at build time:
 *   reports  — Orca AI Reports
 *   security — Orca AI Approvals & Security
 */
import {
  Workflow,
  ShieldCheck,
  MessageSquare,
  Database,
  Search,
  Library,
  Terminal,
  ClipboardCheck,
  ShieldAlert,
} from 'lucide-react';
import BrainstormIcon from './AiCopilot/BrainstormIcon';

export const PRODUCTS = {
  reports: {
    id: 'reports',
    name: 'Orca AI',
    tagline: 'Reports',
    defaultView: 'ask-data',
    copilotViews: [
      { id: 'ask-data', label: 'Ask Data', icon: BrainstormIcon },
      { id: 'sql-studio', label: 'SQL Studio', icon: Terminal },
      { id: 'report', label: 'Report Copilot', icon: MessageSquare },
    ],
    adminViews: [
      { id: 'reports-catalog', label: 'Reports Catalog', icon: Library },
      { id: 'hdl-errors', label: 'HDL Errors', icon: ShieldAlert },
      { id: 'connections', label: 'Connections', icon: Database },
    ],
  },
  security: {
    id: 'security',
    name: 'Orca AI',
    tagline: 'Approvals & Security',
    defaultView: 'ask-data',
    copilotViews: [
      { id: 'ask-data', label: 'Ask Data', icon: BrainstormIcon },
      { id: 'bpm', label: 'Approval Copilot', icon: Workflow },
      { id: 'approval-designer', label: 'Approval Designer', icon: Workflow },
      { id: 'security', label: 'Security Copilot', icon: ShieldCheck },
    ],
    adminViews: [
      { id: 'users', label: 'User Lookup', icon: Search },
      { id: 'uar', label: 'Access Review', icon: ClipboardCheck },
      { id: 'audit-alerts', label: 'Audit Alerts', icon: ShieldAlert },
      { id: 'sod-rules', label: 'SoD Rules', icon: ShieldCheck },
      { id: 'connections', label: 'Connections', icon: Database },
    ],
  },
};

const PRODUCT_KEY = String(process.env.REACT_APP_ORCA_PRODUCT || 'reports').trim().toLowerCase();

export function getProduct() {
  return PRODUCTS[PRODUCT_KEY] || PRODUCTS.reports;
}

export function getAllViews(product = getProduct()) {
  return [...product.copilotViews, ...product.adminViews];
}

export function isViewAllowed(viewId, product = getProduct()) {
  return getAllViews(product).some((v) => v.id === viewId);
}
